import { resolveBasePath } from "../base-path.js";

export const basePath = resolveBasePath();
